import '../../../App.css'
import { useState, useEffect } from 'react';
import { Input, Table, Select, Pagination } from 'antd';
import moment from 'moment';
import axios from 'axios';
import Appconfig from '../../../config/config'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import { format } from 'date-fns';
import 'react-calendar/dist/Calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';


function BetsList({ user_id }) {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))

    // Default: from_date = 7 days ago at 11:59, to_date = today at 11:59
        const defaultFrom = moment().subtract(7, 'days').set({ hour: 11, minute: 59 }).toDate();
        const defaultTo = moment().set({ hour: 11, minute: 59 }).toDate();
    
        const [formData, setFormData] = useState({
            "user_id": user_id ? user_id : userInfo._id,
            "type": "0",
            "from_date": defaultFrom,
            "to_date": defaultTo,
            "game_type": "All",
        });

    const options = {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true // Enables 12-hour clock with AM/PM
    };

    // ***************  Calendar Start ****************

    const [showFromCalendar, setShowFromCalendar] = useState(false);

    const handleFromDate = (newDate) => {

        if (newDate) {
            setFormData({
                ...formData,
                from_date: newDate
            })
            setShowFromCalendar(false);
        }
        // Hide the calendar after selecting a date
    };

    const toggleFromCalendar = () => {
        setShowFromCalendar(!showFromCalendar);
        setShowToCalendar(false);
    };

    const [showToCalendar, setShowToCalendar] = useState(false);

    const handleToDate = (newDate) => {
        if (newDate) {
            setFormData({
                ...formData,
                to_date: newDate
            })
            //   setToDate(newDate);
            setShowToCalendar(false); // Hide the calendar after selecting a date
        }

    };

    const toggleToCalendar = () => {
        setShowToCalendar(!showToCalendar);
        setShowFromCalendar(false);
    };
    const formattedFromDate = formData.from_date ? format(formData.from_date, 'dd-MM-yyyy') : format(new Date, 'dd-MM-yyyy');
    const formattedToDate = formData.to_date ? format(formData.to_date, 'dd-MM-yyyy') : format(new Date, 'dd-MM-yyyy');

    // ***************  Calendar End ****************


    const onChangeBetStatus = (betstatus) => {

        setFormData({
            ...formData,
            "status": betstatus
        })
    }
    const onChangeSportType = (sporttype) => {
        setFormData({
            ...formData,
            "event_type": sporttype
        })
    }

    let locale = {
        emptyText: 'No data!',
    };
    const columns = [

        {
            title: 'Sport Name',
            dataIndex: 'name',
            sorter: true,
            width: '35%',
            render: (_, record) => (
                record.event_type == 4 ?
                    (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Cricket
                        </span>
                    ) : record.event_type == 2 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Tennis
                        </span>
                    ) : record.event_type == 1 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Soccer
                        </span>
                    ) : record.event_type == 777 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            WCO Casino
                        </span>
                    ) : record.event_type == 7 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Horse Racing
                        </span>
                    ) : record.event_type == 66102 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Casino
                        </span>
                    ) : record.event_type == 4339 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Greyhound Racing
                        </span>
                    ) : record.event_type == 27979456 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Kabaddi
                        </span>
                    ) : record.event_type == 7522 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Basketball
                        </span>
                    ) : record.event_type == 2378961 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Politics
                        </span>
                    ) : record.event_type == 66101 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Virtual
                        </span>
                    ) : record.event_type == 66104 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Lottery
                        </span>
                    ) : (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Other
                        </span>
                    )
            ),
        },
        {
            title: 'Event Name',
            dataIndex: 'name',
            sorter: true,
            width: '50%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.event_type == 777 ? record?.remarks.split('(')[0].trim() : record?.event_name}
                </span>
            )
        },
        {
            title: 'Market name',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.event_type == "777" ? record?.game_code : record?.market_name}
                </span>
            )
        },
        {
            title: 'Selection',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.event_type == "777" ? '-' : record?.runner_name}
                </span>
            )
        },
        {
            title: 'Type',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{
                    record.event_type == "777" ? (
                        <div className=''>
                            {record?.transaction_type}
                        </div>
                    ) :
                        record.is_back == 0 ?
                            (
                                <span className='font-extrabold text-[#d50000] text-[0.813rem] '>
                                    Lay
                                </span>
                            ) :
                            (
                                <span className='font-extrabold text-[#09437f] text-[0.813rem] '>
                                    Back
                                </span>
                            )
                }
                </span>
            )
        },
        {
            title: 'Odds Req.',
            dataIndex: 'name',
            sorter: false,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record.event_type == 777 ? '-' : Number(record.price_val).toFixed(2)}</span>
            )
        },
        {
            title: 'Stack',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record.event_type == 777 ? record?.amount : Number(record.stake).toFixed(2)}</span>
            )
        },
        {
            title: 'Place Time',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => {
                // Extract the date part before 'T'
                const date = new Date(record.createdAt);
                const formattedDate = date.toLocaleString('en-US', options);

                return (
                    <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                        {formattedDate}
                    </span>
                );
            }
        },
        {
            title: 'Settle Time',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => {
                // Extract the date part before 'T'
                const date = new Date(record.updatedAt);
                const formattedDate = date.toLocaleString('en-US', options);
                return (
                    <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                        {formattedDate}
                    </span>
                );
            }
        },
    ];

    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1); // Reset to the first page after changing page size
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredData?.length > 0 && filteredData.slice(startIndex, endIndex);


    useEffect(() => {
        filterBetHistory();
    }, [])

    const filterBetHistory = async (e) => {

        var data = JSON.stringify(formData);

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/aurafilterbetHistory`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                try {
                    console.log(response.data.resultData);
                    setFilteredData(response.data.resultData);

                } catch (e) {
                    // postErrorToslack(e.message);
                }
            })
            .catch(function (error) {
                console.log(error);
                // postErrorToslack(error.message);
            });
    }

    const onChangeDataType = (datatype) => {
        if (datatype == "LIVE") {
            setFormData({
                ...formData,
                from_date: moment().format('YYYY-MM-DD')
            })
        } else if (datatype == "BACKUP") {
            setFormData({
                ...formData,
                from_date: moment().subtract(3, 'month').format('YYYY-MM-DD')
            })
        } else if (datatype == "OLD") {
            setFormData({
                ...formData,
                from_date: moment().subtract(1, 'year').format('YYYY-MM-DD')
            })
        }

    }



    return (
        <div className='grid grid-cols-12 relative ' >
            <div className="col-span-12 mb-[1.5rem] lg:mb-0">
                <div className="w-full bg-[#e0e6e6] border border-[#000501] rounded-[.25rem] p-4">
                    <div className="flex flex-wrap gap-4">

                    {/* Type */}
                    <div className="flex-1 min-w-[120px]">
                        <label className="block mb-1 text-[0.813rem] text-[#212529] font-normal">Type</label>
                        <select
                        id="typeSelect"
                        className="appearance-none block w-full px-3 py-1 text-[0.875rem] text-[#5c6873] border border-[#ccc] rounded-[.25rem] bg-[url('https://aura444.com/Down-Arrow.696f11d0c8727f3b.svg')] bg-no-repeat bg-[length:12px_12px] bg-[right_0.75rem_center]"
                        defaultValue="Settled"
                        onChange={(e) => onChangeBetStatus(e.target.value)}
                        >
                        <option value="Settled">Settle</option>
                        <option value="Open">UnSettle</option>
                        <option value="void">Void</option>
                        </select>
                    </div>

                    {/* Sport */}
                    <div className="flex-1 min-w-[120px]">
                        <label className="block mb-1 text-[0.813rem] text-[#212529] font-normal">Sport</label>
                        <select
                        id="sport"
                        className="appearance-none block w-full px-3 py-1 text-[0.875rem] text-[#5c6873] border border-[#ccc] rounded-[.25rem] bg-[url('https://aura444.com/Down-Arrow.696f11d0c8727f3b.svg')] bg-no-repeat bg-[length:12px_12px] bg-[right_0.75rem_center]"
                        defaultValue="ALL"
                        onChange={(e) => onChangeSportType(e.target.value)}
                        >
                        <option value="ALL">ALL</option>
                        <option value="4">Cricket</option>
                        <option value="2">Tennis</option>
                        <option value="1">Soccer</option>
                        <option value="777">Casino</option>
                        </select>
                    </div>

                    {/* From */}
                    <div className="flex-1 min-w-[180px]">
                        <label className="block mb-1 text-[0.813rem] text-[#212529] font-normal">From</label>
                        <DatePicker
                        showTime={{ format: 'HH:mm' }}
                        format="DD-MM-YYYY HH:mm"
                        value={dayjs(formData.from_date)}
                        className="w-full"
                        onChange={(date, dateString) =>
                            setFormData({
                            ...formData,
                            from_date: dayjs(dateString, 'DD-MM-YYYY HH:mm').toDate(),
                            })
                        }
                        />
                    </div>

                    {/* To */}
                    <div className="flex-1 min-w-[180px]">
                        <label className="block mb-1 text-[0.813rem] text-[#212529] font-normal">To</label>
                        <DatePicker
                        showTime={{ format: 'HH:mm' }}
                        format="DD-MM-YYYY HH:mm"
                        value={dayjs(formData.to_date)}
                        className="w-full"
                        onChange={(date, dateString) =>
                            setFormData({
                            ...formData,
                            to_date: dayjs(dateString, 'DD-MM-YYYY HH:mm').toDate(),
                            })
                        }
                        />
                    </div>

                    {/* Button */}
                    <div className="flex-none">
                        <Button
                        type="primary"
                        onClick={filterBetHistory}
                        className="bg-[#0c9971] mt-[1.4rem]"
                        >
                        Get History
                        </Button>
                    </div>
                    </div>
                </div>
                </div>


            <div className='col-span-12 mb-[1.5rem] lg:mb-[0px]'>
                <div className=' flex-[0_0_auto] w-full max-w-full'>
                    <div className='border-r-[1px] border-r-[#c8ced3] border-l-[1px] border-l-[#c8ced3] mb-[24px] relative flex flex-col min-w-[0] text-[#212529] [word-wrap:break-word] bg-[#fff] bg-clip-border border-[1px] border-[solid] border-[#0000002d] rounded-[.375rem]'>
                        <div className='bg-[#0c9971] text-[#ffffff] font-bold text-[0.938rem] px-[10px] py-[5px] [word-wrap:break-word]'>
                            <span className='text-[#ffffff] font-bold text-[0.938rem]  py-[5px] [word-wrap:break-word]'>Bet History</span>
                        </div>
                        <div className='p-[1.25rem] flex-auto '>
                            <Table
                                title={() => (
                                    <div className='grid grid-cols-12'>
                                        <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-start mb-[.9rem] lg:mb-[0px]'>
                                            <div className='text-[#333] lg:m-[.5rem]'>
                                                <label>
                                                    Show
                                                    <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px]'>
                                                        <Select.Option value={10}>10</Select.Option>
                                                        <Select.Option value={25}>25</Select.Option>
                                                        <Select.Option value={50}>50</Select.Option>
                                                        <Select.Option value={100}>100</Select.Option>
                                                    </Select>
                                                    entries
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-end'>
                                            <div className='text-[#333] lg:m-[.5rem]'>
                                                <label>
                                                    Search:
                                                    <Input
                                                        // onChange={e => handleSearch(e.target.value, 'name')}
                                                        style={{ width: 155, marginLeft: '5px' }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                locale={locale}
                                columns={columns}
                                className='event-pl'
                                bordered
                                dataSource={paginatedData}
                                pagination={false} // Disable default pagination
                            />
                            <div className='grid grid-cols-12 items-center pt-[1.5rem] lg:pt-[.75rem] text-[#333]'>
                                <div className='col-span-12 lg:col-span-6 text-[#333] text-[0.813rem]'>
                                    Showing {startIndex + 1} to {endIndex} of {filteredData?.length} entries
                                </div>
                                <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                    <button className='text-[0.813rem] cursor-default text-[#666] border-[1px] border-[solid] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px] cursor-pointer' type='button' onClick={handleFirst} style={{ marginRight: 8 }}>First</button>
                                    <Pagination
                                        current={current}
                                        pageSize={pageSize}
                                        total={filteredData?.length}
                                        onChange={(page) => setCurrent(page)}
                                        itemRender={(page, type, originalElement) => {
                                            if (type === 'prev') {
                                                return <button type='button' className='!cursor-pointer'>Previous</button>;
                                            }
                                            if (type === 'page') {
                                                return null; // Hide page numbers
                                            }
                                            if (type === 'next') {
                                                return <button type='button' className='!cursor-pointer'>Next</button>;
                                            }
                                            return originalElement;
                                        }}
                                        showSizeChanger={false} // Disable default page size changer
                                    />
                                    <button className='text-[0.813rem] cursor-default text-[#666] border-[1px] border-[solid] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px]  cursor-pointer' type='button' onClick={handleLast} style={{ marginLeft: 8 }}>Last</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default BetsList;
